import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import EditorialGallery from "@/components/EditorialGallery";
import PastIssues from "@/components/PastIssues";
import CityDirectory from "@/components/CityDirectory";
import AdBanner from "@/components/AdBanner";
import BannerAds from "@/components/BannerAds";
import AdvertiseSection from "@/components/AdvertiseSection";
import Footer from "@/components/Footer";
import ListingDetail from "@/pages/ListingDetail";
import IssueDetail from "@/pages/IssueDetail";

const Home = () => {
  useEffect(() => {
    document.title = "Texas Journal — A Texas Fashion Magazine";
  }, []);

  return (
    <div className="App bg-white text-[#0a0a0a]">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <EditorialGallery />
        <AdBanner />
        <CityDirectory />
        <BannerAds />
        <PastIssues />
        <AdvertiseSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/listing/:id" element={<ListingDetail />} />
        <Route path="/issue/:id" element={<IssueDetail />} />
      </Routes>
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
